export { DetailsCoverCarousel } from './DetailsCoverCarousel';
